import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import { getThemeTokens, radii } from '../tokens';

export const styledMuiTab = (theme: Theme): BackstageOverrides['MuiTab'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      borderTopLeftRadius: radii.md,
      borderTopRightRadius: radii.md,
      color: tokens.textSecondary,
      fontSize: theme.typography.body1.fontSize,
      fontWeight: 700,
      minHeight: 52,
      padding: theme.spacing(1, 1.75),
      textTransform: 'none',
      transition: 'color 150ms ease, background-color 150ms ease',
      '&.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.main, 0.14),
        color: tokens.textPrimary,
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
        color: tokens.textPrimary,
      },
    },
  };
};
